import { makeObservable, computed, action, observable } from 'mobx'
import ModalViewModel from 'infra/ModalViewModel'
import { task } from 'mobx-task'
import { AlertFactory, AlertState } from '../../../alerts/Alert'
import { Collaborator, RatingMethod } from '../../Job'

/**
 * View Model for rating a pro.
 */
export default class RateProDialogViewModel extends ModalViewModel {
  @observable
  feedback = ''

  @observable
  thumbsRating: boolean | undefined = undefined

  @observable
  rating = 0

  constructor(
    public proChampion: Collaborator | undefined,
    public ratingMethod: RatingMethod,
    private submitProRating: (
      rating: number,
      feedback: string
    ) => Promise<void>,
    private newAlert: AlertFactory
  ) {
    super()
    makeObservable(this)
  }

  @computed
  get validRating() {
    return this.rating >= 1 && this.rating <= 5
  }

  @action.bound
  setRating(value: number) {
    this.rating = value
  }

  @action.bound
  setThumbsRating(value: boolean) {
    this.thumbsRating = value
    this.rating = this.thumbsRating ? 4 : 2
  }

  @action.bound
  ratePro = task.resolved(async () => {
    if (!this.validRating) {
      return
    }

    const alert = this.newAlert()
      .withState(AlertState.Pending)
      .saying('Submitting rating')
      .autoDismiss()
      .show()

    try {
      await this.submitProRating(this.rating, this.feedback)

      alert
        .withState(AlertState.Success)
        .saying('Success!', 'Your rating was submitted')
        .autoDismiss()

      this.close()
    } catch (e) {
      console.error(e)

      alert.fromError(e).autoDismiss()
    }
  })
}
